import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "code-transparent",
  "use": "code-transparent-usage",
  "viewBox": "0 0 40 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 40 32\" id=\"code-transparent\">\n    <title>icon-editor-code</title>\n    <path d=\"M26 23l3 3 10-10-10-10-3 3 7 7z\" />\n    <path d=\"M14 9l-3-3-10 10 10 10 3-3-7-7z\" />\n    <path d=\"M21.916 4.704l2.171 0.592-6 22.001-2.171-0.592 6-22.001z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol